<template>
    <v-field :has-error="hasError" :error-label="errorLabel" :helper="helper" >
        <q-input v-model="inputValue"
                 :name="nameRandom"
                 :dusk="path"
                 :clearable="clearable"
                 :float-label="processedLabel"
                 :stack-label="processedLabel"
                 :type="type"
                 :color="color"
                 :min-rows="minRows"
                 :disable="form.busy || disable"
                 :autofocus="autofocus"
                 :hide-underline="hideUnderline"
                 :prefix="prefix"
                 @input="onInput"
                 :before="before"
                 :after="after"
                 :maxlength="maxlength"
                 :rows="rows"
                 :autocomplete="autocomplete"
                 @blur="event => $emit('blur', event)"></q-input>
    </v-field>
</template>

<script>
    import mixins from './mixins'
    import {QInput} from 'quasar-framework'

    export default {
        name: 'VInput',

        mixins,

        props: {
            type: {
                type: String,
                default: 'text'
            },
            minRows: {
                type: Number,
                default: 1
            },
            rows: {
                type: Number,
                default: 1
            },
            autofocus: Boolean,
            prefix: String,
            maxlength: Number,
            autocomplete: {
                type: String,
                default: (this.path === 'password' || this.path === 'password_confirmation') ? 'new-password' : 'off'
            }
        },

        data() {
            return {
                inputValue: this.value || ''
            }
        },

        computed: {
            nameRandom () {
                if (this.path === 'name' || this.path === 'email' || this.path === 'alert_email' || this.path === 'password' || this.path === 'password_confirmation') {
                    return Math.floor((Math.random() * 9999999999) + 1);
                }

                return this.path
            },
        },

        components: {
            QInput
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/VInput.vue